import {
  EntrancePlantDetailDTO,
  EntrancePlantInfoCreateDTO,
} from '@/../client-generator/generated-clients/plants';
import { mapState } from 'vuex';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'DeviceInformationTab',
  props: {
    infoPlant: {
      type: EntrancePlantInfoCreateDTO,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: {},
  emits: ['update-list'],
})
export default class DeviceInformationTab extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  infoPlant!: EntrancePlantDetailDTO;
  noData = '';

  gatesDevicesInfo: {[gateId: string]: {name: string, firmwareVersion?: string, macAddress?: string}[]} = {};

  mounted() {
    this.noData = this.$t('AppResource.Noassociateddevice');
    this.initializeData();
  }

  initializeData() {
    if(!this.currentEntrancePlant.gates) return;
    this.currentEntrancePlant.gates.forEach(gate => {
      if(!gate.devices || !gate.gateId) return;
      gate.devices.forEach(device => {
        if(device.deviceName) {
          if(!this.gatesDevicesInfo[gate.gateId!]) {
            this.gatesDevicesInfo[gate.gateId!] = [];
          }
          this.gatesDevicesInfo[gate.gateId!].push({
            name: device.deviceName,
            firmwareVersion: device.firmwareVersion,
            macAddress: device.dspMacAddress,
          });
        }
      });
    });
  }

  fieldHasValue(field: string | undefined) {
    return !!field && field.trim() !== '';
  }

  firmwareVersion(firmware: string | undefined) {
    return this.fieldHasValue(firmware) ? firmware : this.noData;
  }

  macAddress(mac: string | undefined) {
    return this.fieldHasValue(mac) ? mac : this.noData;
  }

  isLast(index: number) {
    if(!this.currentEntrancePlant.gates) return true;
    return index === this.currentEntrancePlant.gates.length - 1;
  }
}